//dependencies
import React, { useState } from "react";

//components
import ContentModal from "../../../../../components/Modal/Templates/ContentModal";
import EditAvatarModalContents from "./components/EditAvatarModalContents";
import ViewAvatarModalContents from "./components/ViewAvatarModalContents";

//css
import css from "./AvatarModal.module.scss";

export type AvatarModalProps = {
	isOpen: boolean;
	handleClose: () => void;
	userID: string;
};

const AvatarModal = ({ isOpen, handleClose, userID }: AvatarModalProps) => {
	const [file, setFile] = useState<File | null>(null);

	const onClose = () => {
		setFile(null);
		handleClose();
	};

	return (
		<ContentModal isOpen={isOpen} handleClose={onClose} contentClassName={css.AvatarModal}>
			{file ? (
				<EditAvatarModalContents
					handleClose={() => {
						setFile(null);
						handleClose();
					}}
					userID={userID}
					file={file}
					setFile={setFile}
				/>
			) : (
				<ViewAvatarModalContents handleClose={handleClose} userID={userID} setFile={setFile} />
			)}
		</ContentModal>
	);
};

export default AvatarModal;
